class VideoMetaDataGenerator {
  constructor(video) {
    this.video = typeof video === 'string' ? video : URL.createObjectURL(video)
  }

  async generate() {
    const videoElement = await this._createVideoElement()
    const metadata = { duration: videoElement.duration }
    videoElement.remove()
    return metadata
  }

  _createVideoElement() {
    return new Promise((resolve) => {
      const videoElement = document.createElement('video')
      videoElement.src = this.video
      videoElement.load()
      videoElement.style = 'visibility: hidden'
      videoElement.addEventListener('loadedmetadata', () => {
        resolve(videoElement)
      })
    })
  }
}

export default VideoMetaDataGenerator
